import { render, staticRenderFns } from "./configurationFourth.vue?vue&type=template&id=54525f74&scoped=true&"
import script from "./configurationFourth.vue?vue&type=script&lang=js&"
export * from "./configurationFourth.vue?vue&type=script&lang=js&"
import style0 from "./configurationFourth.vue?vue&type=style&index=0&id=54525f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54525f74",
  null
  
)

export default component.exports